
let modifiers = [];

const context = require.context('./', false, /^\.\/(?!index|.*\.test\.js$).+\.js$/);

modifiers = context.keys().map(key => context(key).default);

modifiers.sort((a, b) => a.order - b.order);

export default modifiers;